import { http } from "@/http";

class LabelService {
  async getImeiByLabel(label) {
    label=encodeURIComponent(label)
    return await http.get(`/access-label/get-imei-by-label/${label}`);
  }

  async updateLabelsToImei(imei, labelLIst) {
    let body = {
      imei: imei,
      accessLabel: labelLIst.toString(),
    };
    return await http.post(`/access-label/create-update`, body);
  }

  async getLabelsByImei(imei) {
    return await http.get(`/access-label/getByImei/${imei}`);
  }
  async getAllLabels() {
    return await http.get(`/access-label/get-label-list`);
  }
}
export default new LabelService();
